import {getPanelSpec, type LayedOutPanel} from '../../../../util/panelTypes';
import {useRampFlagMediaSettingsDrawerAllTypesUser} from '../../../../util/rampFeatureFlags/rampFeatureFlags';
import {panelViews} from '../../../PanelBank/types';

/** Whether adding a panel of this type in a workspace skips the edit modal and opens the settings drawer. */
export const useShouldOpenSettingsDrawerOnCreate = (
  viewType: LayedOutPanel['viewType'] | undefined
): boolean => {
  const isMediaSettingsDrawerAllTypesEnabled =
    useRampFlagMediaSettingsDrawerAllTypesUser() === true;
  if (viewType == null) {
    return false;
  }
  const panelSpec = getPanelSpec(viewType);
  if (
    !panelSpec.openSettingsDrawerOnCreate ||
    panelSpec.settingsDrawerContent == null
  ) {
    return false;
  }
  return (
    viewType !== panelViews.mediaBrowser || isMediaSettingsDrawerAllTypesEnabled
  );
};
